"use strict";

import { GEOLOCATION } from "../constants";
import { getLocalStorage, setLocalStorage, removeLocalStorageKey } from "../helpers/localStorage";

const $currentCityNotification    = $(".current-city-notification");
const isCityNotificationDismissed = getLocalStorage(GEOLOCATION.IS_CITY_NOTIFICATION_DISMISSED);

const onSuccessGeolocationRequest = ({ coords }) => {
    const { latitude, longitude } = coords;
    const $localitySelectionUrl   = $(".js-search-select-city-form").attr("action");

    const savedGeolocationData        = getLocalStorage(GEOLOCATION.SESSION_STORAGE_KEYS.COORDINATES);

    setLocalStorage(GEOLOCATION.SESSION_STORAGE_KEYS.PERMISSION_STATUS, GEOLOCATION.STATUS_CODES.PERMISSION_GRANTED);

    setLocalStorage(GEOLOCATION.SESSION_STORAGE_KEYS.COORDINATES, {
        latitude,
        longitude
    });

    if (isCityNotificationDismissed === null) {
        $currentCityNotification.removeAttr("hidden");
    }

    if (isCityNotificationDismissed || savedGeolocationData) {
        return;
    }

    $.ajax({
        url: $localitySelectionUrl,
        type: "POST",
        data: {
            latitude: latitude,
            longitude: longitude
        },
        success: ({ success }) => {
            if (success) {
                location.reload();
            } else {
                if (isCityNotificationDismissed === null) {
                    $currentCityNotification.removeAttr("hidden");
                }
            }
        },
        error: () => {
            if (isCityNotificationDismissed === null) {
                $currentCityNotification.removeAttr("hidden");
            }
        },
    });
};

const onErrorGeolocationRequest = ({ code }) => {
    if (isCityNotificationDismissed === null) {
        $currentCityNotification.removeAttr("hidden");
    }

    setLocalStorage(GEOLOCATION.SESSION_STORAGE_KEYS.PERMISSION_STATUS, code);
    removeLocalStorageKey(GEOLOCATION.SESSION_STORAGE_KEYS.COORDINATES);
};

const initializeBrowserGeolocation = () => {
    navigator.geolocation.getCurrentPosition(
        onSuccessGeolocationRequest,
        onErrorGeolocationRequest,
        GEOLOCATION.OPTIONS
    );
};

export default initializeBrowserGeolocation;
